import { parseRarityName } from '$lib/utils';
import { faCalendarDays, faPenFancy, faStars } from '@fortawesome/pro-solid-svg-icons';

import isDarkColor from 'is-dark-color';

export default (data) => ({
  relationKey: 'sticker',
  relationItem: data.item.sticker,
  content: {
    collection: data.item.inLootlists.find((x) => x.collection)?.collection || null,
    tableData: [
      data.item.inLootlists.find((x) => x.collection) && {
        header: 'Collection',
        data: data.item.inLootlists.find((x) => x.collection).collection.name,
      },
      data.item.sticker.proTeam && {
        header: 'Team',
        data: data.item.sticker.proTeam.name,
      },
      data.item.sticker.proPlayer && {
        header: 'Player',
        data: data.item.sticker.proPlayer.name,
      },
      data.item.sticker.proEvent && {
        header: 'Tournament',
        data: data.item.sticker.proEvent.name,
      },
    ],
    stickyBox: {
      image: { obj: data.item.image, alt: data.item.name },
      rarity: data.item.rarity,
      title: data.item.name,
      subtitle: `${parseRarityName(data.item.rarity)} Agent Patch`,
      link: { label: `Other Patches`, href: `/skins/patches` },
    },
    priceFetcher: (item) => item.sticker.steamValue,
    infoBoxes: [
      {
        icon: faPenFancy,
        label: 'Patch Film',
        value: data.item.sticker.film?.name || 'Generic',
        modifiers: ['sticker', data.item.sticker?.film?.slug || ''],
      },

      {
        icon: faStars,
        label: 'Rarity',
        value: parseRarityName(data.item.rarity),
        style: `--col-rarity:${data.item.rarity.hexColor}`,
        modifiers: ['rarity', data.item.rarity.slug].concat(!isDarkColor(data.item.rarity.hexColor) ? ['dark'] : []),
      },
    ],
  },
});
